import { Slider, Modal } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SoilSearchProperties from '@/components/SoilSearchProperties';
import { RootState } from '@/redux';
import { updatePropertyList, updateSearchRadiusSetting, updateSecondTabValues } from '@/redux/reducer/soilSerach';
import { SoilProfileWarningAlertIcon, SoilSearchClearIcon } from '@/resource/IconComponentSets';
import { GetPropertyList, soilSearchGetRadiusSetting } from '@/util/Request';
import { GetPropertyListResponseModel } from '@/util/Request/requestType';
import SoilLatLonInputSelectComponent from '../SoilLatLonInputSelectComponent';
import './index.less';

const { confirm } = Modal;

interface IProps {
    // getCurrentRadiusCallback?: (currentRadius: number) => void
    // getCoordinatesSet?: (latitudeAndLongitude: string[]) => void
    // getSelectedPropertySet?: (propertySet: GetPropertyListResponseModel[]) => void
    excuteButtonClick?: () => void
    saveQueryButtonClick?: () => void
}

const CoordinateBaseTab = (props: IProps) => {
    const {
        // getCurrentRadiusCallback,
        // getCoordinatesSet,
        // getSelectedPropertySet,
        excuteButtonClick,
        saveQueryButtonClick
    } = props;

    // const [currentRadius, setCurrentRadius] = useState(1);
    const [selectedProperty, setSelectedProperty] = useState<GetPropertyListResponseModel>();
    // const [selectedPropertySet, setSelectedPropertySet] = useState<GetPropertyListResponseModel[]>([]);
    const [lonLatString, setLonLatString] = useState<string>('');
    // const [coordinateSet, setCoordinateSet] = useState<string[]>([]);

    const dispatch = useDispatch();

    const {
        radiusSetting,
        soilPropertyList,
        coordinateTabPropertiesSet,
        coordinatesSet,
        coordinateTabRadius
    } = useSelector((state: RootState) => state.soilSearchPageData);

    const handlePropertyListSelect = (record: GetPropertyListResponseModel) => {
        setSelectedProperty(record);
        let haveAdded = false;
        let chemicalAllTagAdded = false;
        let physicalAllTagAdded = false;
        coordinateTabPropertiesSet.forEach((item) => {
            if (record.id === item.id) {
                haveAdded = true;
            }
            if (item.id === -10) {
                chemicalAllTagAdded = true;
            }
            if (item.id === -20) {
                physicalAllTagAdded = true;
            }
        });

        // duplicated selected item filter
        if (haveAdded) {
            return;
        }
        // console.log('record.category:==', record.category);
        // console.log('physicalAllTagAdded', physicalAllTagAdded);
        // console.log('chemicalAllTagAdded', chemicalAllTagAdded);

        // console.log('record.category === ', record.category === 'Physical' && physicalAllTagAdded);
        // console.log('record.category === ', record.category === 'Chemical' && chemicalAllTagAdded);
        if ((record.category === 'Physical' && physicalAllTagAdded) || (record.category === 'Chemical' && chemicalAllTagAdded)) {
            return;
        }

        // normal selected handle method
        if (record.id === -10) {
            const newSelectedPropertySet = coordinateTabPropertiesSet.filter((item) => item.category !== 'Chemical' || item.id === -20);
            dispatch(updateSecondTabValues({
                coordinateTabPropertiesSet: [record, ...newSelectedPropertySet]
            }));
            // setSelectedPropertySet([record, ...newSelectedPropertySet]);
            return;
        }

        if (record.id === -20) {
            const newSelectedPropertySet = coordinateTabPropertiesSet.filter((item) => item.category !== 'Physical' || item.id === -10);
            dispatch(updateSecondTabValues({ coordinateTabPropertiesSet: [record, ...newSelectedPropertySet] }));
            // setSelectedPropertySet([record, ...newSelectedPropertySet]);
            return;
        }

        const cachePropertySelectedList = [...coordinateTabPropertiesSet];
        cachePropertySelectedList.push(record);
        dispatch(updateSecondTabValues({
            coordinateTabPropertiesSet: cachePropertySelectedList
        }));
        // setSelectedPropertySet(cachePropertySelectedList);
    };

    // SECTION: useEffect are
    useEffect(() => {
        requestForRadiusSeting();
        requestForSoilProperties();
    }, []);

    const requestForRadiusSeting = useCallback(async () => {
        try {
            const res = await soilSearchGetRadiusSetting();
            dispatch(updateSearchRadiusSetting(res));
        } catch (err) {
            console.log(err);
        }
    }, []);

    const requestForSoilProperties = useCallback(async () => {
        try {
            const res = await GetPropertyList();
            dispatch(updatePropertyList([...res]));
        } catch(err) {
            console.log(err);
        }
    }, []);


    const handleDeleteItemTag = (removeTargetItem: string, index: number) => {
        console.log('delete lat lon item tag');
        const newCoordinateSet = [...coordinatesSet];
        newCoordinateSet.splice(index, 1);
        dispatch(updateSecondTabValues({
            coordinatesSet: [...newCoordinateSet]
        }));
        // setCoordinateSet([...newCoordinateSet]);
    };

    const handleRemoveProperty = (removeItem: GetPropertyListResponseModel) => {
        const removedProperty = [];
        coordinateTabPropertiesSet.forEach((item: GetPropertyListResponseModel) => {
            if (item.id !== removeItem.id) {
                removedProperty.push(item);
            }
        });
        dispatch(updateSecondTabValues({
            coordinateTabPropertiesSet: removedProperty
        }));
        // setSelectedPropertySet(removedProperty);
    };

    const commomWarning = (message: string) => {
        return confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                        Warning
                    </span>
                </div>),
            content: message,
            okText: 'OK',
            onCancel() {
                console.log('Cancel');
            },
            onOk: () => {
                console.log('click ok button');
            }
        });
    };

    const clearAllRequestCondition = () => {
        // setCurrentRadius(1);
        // setSelectedPropertySet([]);
        dispatch(updateSecondTabValues({
            coordinateTabRadius: 1,
            coordinateTabPropertiesSet: [],
            coordinatesSet: []
        }));
    };

    const handleExcuteButtonClick = () => {
        if (!coordinatesSet.length) {
            return commomWarning('Must input at leaset a coordinate ?');
        }

        if (!coordinateTabPropertiesSet.length) {
            return commomWarning('Must select at least a property?');
        }
        excuteButtonClick();
    };

    const onChange = (e) => {
        const { value } = e.target;
        const handledValue = value.replace(/[^\-?\d.],[^\-?\d.]/g, '');
        setLonLatString(handledValue);
    };

    const handleAddButtonClick = () => {
        const validate = validateLatLon(lonLatString);
        if (!validate) {
            return commomWarning('Coordinate value is invalid ?');
        }
        // if same coordinate have exist in arr;
        const index = coordinatesSet.indexOf(lonLatString);
        if (index > -1) {
            return commomWarning('Coordinate value is depreacted ?');
        }
        const lonLatArr = lonLatString.split(',');
        const localLonLatString = `(${lonLatArr[0]},${lonLatArr[1]})`;
        const newCoordinateSet = [...coordinatesSet];
        newCoordinateSet.push(`${localLonLatString}`);
        // setCoordinateSet(newCoordinateSet);
        dispatch(updateSecondTabValues({
            coordinatesSet: newCoordinateSet
        }));
        setLonLatString('');
    };

    const validateLatLon = (lonLat: string): boolean => {
        const lonLatArr = lonLat.split(',');
        if (lonLatArr.length !== 2) {
            return false;
        }

        if (lonLatArr.length === 2) {
            const lat = parseFloat(lonLatArr[1]);
            const lng = parseFloat(lonLatArr[0]);
            let latValidate = true;
            if (lat <= 90 && lat >= -90) {
                latValidate = true;
            } else {
                latValidate = false;
            }
            let lngValidate = true;
            if (lng <= 180 && lng >= -180) {
                lngValidate = true;
            } else {
                lngValidate = false;
            }
            return latValidate && lngValidate;
        } else {
            return false;
        }
    };

    // if place select set changed
    // useEffect(() => {
    //     getCoordinatesSet(coordinateSet);
    // }, [coordinateSet]);

    // // if properties select set chagned
    // useEffect(() => {
    //     getSelectedPropertySet(selectedPropertySet);
    // }, [selectedPropertySet]);

    // useEffect(() => {
    //     getCurrentRadiusCallback(currentRadius);
    // }, [currentRadius]);

    return (
        <div className='tabs-container'>
            <SoilLatLonInputSelectComponent
                onChange={(e) => onChange(e)}
                addButtonClick={() => handleAddButtonClick()}
                value={lonLatString}
            />
            <div className='add-selected-place-div'>
                {coordinatesSet.map((item, index) => {
                    return (
                        <span
                            className='add-selected-place-tag'
                            key={`${item}-${index}`}
                        >
                            {/*The page needs to display latitude and longitude, but the data passed into the background is longitude and latitude*/}
                            {(((item.replace('(', '').replace(')', '')).split(','))).join(',')}
                            <button onClick={() => handleDeleteItemTag(item, index)}>
                                <SoilSearchClearIcon className='close-icon-style' />
                            </button>
                        </span>
                    );
                })}
            </div>
            <div className='location-neighbor-area-div'>
                <p>Neighbor Soil Analysis location in radius, km</p>
                <div className='slider-super-div'>
                    <Slider
                        className='slider-own'
                        min={1}
                        max={radiusSetting.maxValue}
                        defaultValue={1}
                        onChange={(value)=> {
                            // setCurrentRadius(value);
                            dispatch(updateSecondTabValues({
                                coordinateTabRadius: value
                            }));
                        }}
                        value={coordinateTabRadius}
                    />
                    <div className='radius-value-div'>
                        {coordinateTabRadius}
                    </div>
                </div>
                <p>Locations in this radius will be included</p>
            </div>
            <h4>Soil Properties</h4>
            <SoilSearchProperties
                dataSource={soilPropertyList}
                selectedText={selectedProperty && selectedProperty.name}
                selectTargetPropertiesCallback={(record) => handlePropertyListSelect(record)}
            />
            <div className='soil-properties-tag'>
                <div className='inner-div'>
                    {coordinateTabPropertiesSet.map((item) => (
                        <div className='property-tag' key={item.id}>
                            <span className={item.category === 'Chemical' ?
                                'chemical-categoty-span' : 'physical-category-span'}>
                                {item.category}
                            </span>
                            {item.name}
                            <button onClick={() => handleRemoveProperty(item)}>
                                <SoilSearchClearIcon className='close-icon-style' />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            <div className='bottom-button-div'>
                <button className='clear-button' onClick={clearAllRequestCondition}>
                    Clear
                </button>
                <div>
                    <button
                        className='clear-button'
                        onClick={saveQueryButtonClick}
                    >
                    Save Query
                    </button>
                    <button
                        onClick={() => handleExcuteButtonClick()}
                        className='fill-soil-properties'>
                        {coordinatesSet.length > 0 ? ( coordinateTabPropertiesSet.length > 0 ? 'Execute' : 'Fill soil properties') : 'Fill location'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CoordinateBaseTab;